import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex);

const TOGGLE_MODAL_CHOOSE_CARDS = 'TOGGLE_MODAL_CHOOSE_CARDS';
const TOGGLE_YES_CHOOSE_CARDS = 'TOGGLE_YES_CHOOSE_CARDS';
const SET_ID_CHOOSE_CARDS = 'SET_ID_CHOOSE_CARDS';
const REFUND_MODAL_TOGGLE = 'REFUND_MODAL_TOGGLE';
const REFUND_MODAL_ID_CLEAR = 'REFUND_MODAL_ID_CLEAR';
const REFUND_MODAL_ID_SET = 'REFUND_MODAL_ID_SET';

const state = {
    filterType: 'week',
    filterDateFrom: moment().subtract(7,'d').format('YYYY-MM-DD'),
    filterDateTo: moment().format('YYYY-MM-DD'),
    filterPaymentType: 0,
    loading: 0,
    submenu: 'main',
    linkSubmenu: 'payin',
    analyticsData: {},
    merchant: {},
    admin: {},
    merchantId: null,
    acquiringId: 0,
    mpsId: 0,
    acquirerId: 0,
    transactionIndex: 1,
    refundModal: false,
    refundModalCurrentId: null,
    chooseCards: {
        modal: false,
        yes: false,
        id: null
    }
};

const mutations = {
    setFilteDateFrom (state, payload) {
        state.filterType = payload.filterType;
        state.filterDateTo = payload.dateTo || moment().format('YYYY-MM-DD');
        state.filterDateFrom = payload.dateFrom;
    },
    setFilterPaymentType(state, paymentType) {
        state.filterPaymentType = paymentType;
    },
    setLoading (state) {
        state.loading++;
    },
    unsetLoading (state) {
        state.loading--;
    },
    setSubmenu(state, type) {
        state.submenu = type;
    },
    setLinkSubmenu(state, submenu) {
        state.linkSubmenu = submenu;
    },
    setMerchant(state, merchant) {
        state.merchant = merchant;
    },
    setAdmin(state, response) {
        state.admin = response.admin;
        state.admin.merchants = response.merchants;
        state.merchantId = state.admin.merchants[0].id;
    },
    setMerchantId(state, merchantId) {
        state.merchantId = merchantId;
    },
    setAcquiringId(state, acquiringId) {
        state.acquiringId = acquiringId;
    },
    setMpsId(state, mpsId) {
        state.mpsId = mpsId;
    },
    setAcquirerId(state, acquirerId) {
        state.acquirerId = acquirerId;
    },
    [TOGGLE_MODAL_CHOOSE_CARDS](state, payload) {
        state.chooseCards.modal = payload
    },
    [TOGGLE_YES_CHOOSE_CARDS](state, payload) {
        state.chooseCards.yes = payload
    },
    [SET_ID_CHOOSE_CARDS](state, payload) {
        state.chooseCards.id = payload
    },
    [REFUND_MODAL_TOGGLE](state, payload) {
        state.refundModal = payload;
    },
    [REFUND_MODAL_ID_CLEAR](state) {
        state.refundModalCurrentId = null;
    },
    [REFUND_MODAL_ID_SET](state, payload) {
        state.refundModalCurrentId = payload;
    }
};

const actions = {
    toggleModalChooseCards({ commit }, payload) {
        commit(TOGGLE_MODAL_CHOOSE_CARDS, payload)
    },
    toggleYesChooseCards({ commit }, payload) {
        commit(TOGGLE_YES_CHOOSE_CARDS, payload)
    },
    setIdChooseCards({ commit }, payload) {
        commit(SET_ID_CHOOSE_CARDS, payload)
    },
    refundModalToggle({ commit }, payload) {
        commit(REFUND_MODAL_TOGGLE, payload);
        if(!payload) {
            return commit(REFUND_MODAL_ID_CLEAR);
        }
    },
    refundModalIdSet({ commit }, payload) {
        commit(REFUND_MODAL_ID_SET, payload)
    }
}

const store = new Vuex.Store({
    state,
    mutations,
    actions
});
export default store
